export default __webpack_public_path__ + "static/media/axion-stats-light.8a6016b4.png";